import { GridApi } from 'ag-grid-community/dist/lib/gridApi';
export const PERMISSION_CREATE_MESSAGE = 'User roles has been created';
export const PERMISSION_EDIT_MESSAGE =
    'User roles assignment has been updated.Please refresh the Application to see the changes.';
export const PERMISSION_DELETE_MESSAGE = 'User roles has been deleted';
export const PERMISSION_DELETE_FAILED = 'User roles deletion failed';
export const PERMISSION_ASSIGN_FAIILED = 'User roles assignment failed';
export const USER_PERMISSION_TITLE = 'User Permissions';

export const getUserRoleAssignmentHeadersData = (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onAction: (value: boolean, data: any, gridApi: GridApi) => void,
    isActionDisabled: boolean,
    minWidth = 50
) => {
    return [
        {
            field: 'applicationRoleName',
            headerName: 'Name',
            minWidth: minWidth,
            width: 600,
            resizable: true,
            cellRenderer: 'LabelCellRenderer'
        },
        {
            field: 'description',
            headerName: 'Description',
            minWidth: minWidth,
            width: 900,
            resizable: true,
            cellRenderer: 'LabelCellRenderer'
        },
        {
            field: 'access',
            headerName: 'Action',
            minWidth: 150,
            resizable: true,
            cellRenderer: 'UserPermissionCheckboxCellRenderer',
            cellRendererParams: {
                onAction,
                isActionDisabled
            }
        }
    ];
};
